import { customSeriesDefaultOptions, CustomSeriesOptions, IChartApi } from 'lightweight-charts'
import { callColorCumulative, putColorCumulative } from '../../../../multiStikeChart/styles'

import { GroupSeriesHoveredData } from './data'

export interface GroupedBarsSeriesOptions extends CustomSeriesOptions {
    colors: readonly string[]
    barWidth: number
    increaseWidthOnHover: boolean
    disablePadding: boolean
    hoveredData: GroupSeriesHoveredData
    chartApi: IChartApi | undefined
    calculateOffset?: boolean
}

export interface PlusIconSeriesOptions extends CustomSeriesOptions {
    xPosition: number
}

export const defaultOptions: GroupedBarsSeriesOptions = {
    ...customSeriesDefaultOptions,
    colors: [
        callColorCumulative+'80',
        putColorCumulative+'80'
    ],
    barWidth: 1,
    increaseWidthOnHover: false,
    disablePadding: false,
    hoveredData: {
        hoveredTime: NaN,
        hoveredBar: [] as number[]
    },
    chartApi: undefined
} as const
